export default __webpack_public_path__ + "static/cms-abbca2408ead2321332bf7300e4d910d.png";